import {
  LOAD_PROFILE,
  SEARCH_PROFILES,
  UPDATE_PROFILE,
  CONFIRM_PHONE_NUMBER,
  SEND_FEEDBACK,
  RESET_SEARCH_PROFILES,
  RESET_PROFILE_STATE,
} from '../actions/profile.actions';

import {
  profileHasRequiredData,
  profileHasValidatedPhoneNumber
} from '../../utils/validation';

const defaultState = {
  errors: [],
  feedback: {
    submitted: false,
  },
  profile: {
    hasValidatedPhoneNumber: false,
    hasRequiredProfileData: false,
  },
  registration: {
    errors: [],
  },
  searchResults: [],
};


const profileReducer = (state = defaultState, action) => {
  switch (action.type) {
    case RESET_PROFILE_STATE:
      return {
        ...defaultState,
      };
      
    case `${LOAD_PROFILE}_SUCCEEDED`:
      return {
        ...state,
        errors: {},
        profile: action.payload.data,
        hasValidatedPhoneNumber: profileHasValidatedPhoneNumber(action.payload.data),
        hasRequiredProfileData: profileHasRequiredData(action.payload.data),
      };

    case `${LOAD_PROFILE}_FAILED` || `${UPDATE_PROFILE}_FAILED`:
      let errors = { error: ["Server Error"]};

      try {
        errors = action.payload.response.data;
      } catch (err) {}

      return {...state, errors};

    case `${SEARCH_PROFILES}_PENDING`:
      return {
        ...state,
        searchLoading: true,
      };

    case `${SEARCH_PROFILES}_SUCCEEDED`:
      return {
        ...state,
        searchResults: action.payload.data,
        searchLoading: false,
      };

    case `${SEARCH_PROFILES}_FAILED`:
      return {
        ...state,
        searchLoading: false,
      };

    case `${RESET_SEARCH_PROFILES}`:
      return {
        ...state,
        searchResults: defaultState.searchResults,
      };

    case `${UPDATE_PROFILE}_SUCCEEDED`:
      return {
        ...state,
        errors: {},
        profile: action.payload.data,
      };

    case `${CONFIRM_PHONE_NUMBER}_FAILED`:
      return {
        ...state,
        // TODO errors
      };

    case `${CONFIRM_PHONE_NUMBER}_SUCCEEDED`:
      return {
        ...state,
        registration: {
          phoneNumber: action.payload.phoneNumber,
          verificationCode: action.payload.verificationCode,
        }
      };

    case `${SEND_FEEDBACK}_SUCCEEDED`:
      return {
        ...state,
        feedback: { submitted: true}
      };

    default:
      return state;
  }
}

export default profileReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/profile.reducer.js